const getPageAlias = () => window?.DDC?.dataLayer?.page?.pageInfo?.pageName;
const getPagePath = () => window?.DDC?.dataLayer?.page?.pageInfo?.pagePath;
const defined = (item) => typeof item !== 'undefined';

// overrides for specials pages like mslp
let pageTool;
let pageType;

if (
	window?.DDC?.dataLayer?.page?.trackingTags?.pagegroup === 'mslp' ||
	(getPageAlias() === 'SHOWROOM' && getPagePath() !== '/showroom/index.htm')
) {
	pageTool = 'showroom';
	pageType = 'VLP';
}

const pageInfo = {
	default: {
		dealerAddress: '[[address1]], [[city]] [[stateProvince]]',
		dealerId: '[[dealerId]]',
		dealerName: '[[dealershipName]]',
		pageTool: pageTool || '[[mapping.pagealias.pageTool]]',
		siteEnvironment: '[[env]]',
		siteProvider: 'DDC',
		siteTheme: '[[DDC.dataLayer.site.design.themekit]]',
		vehicleModel:
			getPageAlias() === 'SHOWROOM'
				? '[[DDC.dataLayer.page.trackingTags.model]]'
				: '[[DDC.dataLayer.page.trackingTags.model]] >> [[mapping.pagealias.vehicleModel]] >> {{REMOVEKEY}}',
		vehicleYear:
			getPageAlias() === 'SHOWROOM'
				? '[[DDC.dataLayer.page.trackingTags.year]]'
				: '[[DDC.dataLayer.page.trackingTags.year]] >> [[mapping.pagealias.vehicleYear]] >> {{REMOVEKEY}}'
	},
	variant1: {
		brand: '[[fn.getFranchises()]]',
		country: '[[lookup.country]]',
		dealerZip: '[[postalCode]]',
		languageSelected: '[[lookup.locale]]',
		locationBac: '[[fn.getDealerBac()]]',
		orientation: '[[fn.getOrientation()]]',
		pageName:
			'[[fn.getShortFranchises()]]:[[mapping.configuration.region]]:[[lookup.country]]:[[lookup.locale]]:t3:[[fn.getSiteSection5()]]',
		pageSubType: '[[mapping.pagealias.pageSubType]]',
		pageType: pageType || '[[mapping.pagealias.pageType]]',
		region: '[[mapping.configuration.region]]',
		renderedExperience: '[[lookup.layoutType]]',
		seoStrategyPageName:
			window?.DDC?.dataLayer?.page?.trackingTags?.pagegroup === 'mslp'
				? `${window?.DDC?.dataLayer?.page?.trackingTags?.year} ${window?.DDC?.dataLayer?.page?.trackingTags?.model} - Overview`
				: '[[document.title]]',
		siteName: 'tier3',
		siteSectionsLevel1: '[[fn.getSiteSection1()]]',
		siteSectionsLevel2: '[[fn.getSiteSection2()]]',
		siteSectionsLevel3: '[[fn.getSiteSection3()]]',
		siteSectionsLevel4: '[[fn.getSiteSection4()]]',
		siteSectionsLevel5: '[[fn.getSiteSection5()]]',
		url: '[[DDC.dataLayer.page.pageInfo.pageUrl]]',
		vendorName: 'DealerDotCom',
		viewport: '[[fn.getViewport()]]'
	},
	variant2: {
		dealerZipCode: '[[postalCode]]',
		pageHier1: '[[mapping.pagealias.pageHier1]] >> {{REMOVEKEY}}',
		pageHier2: '[[mapping.pagealias.pageHier2]] >> {{REMOVEKEY}}',
		pageHier3: '[[mapping.pagealias.pageHier3]] >> {{REMOVEKEY}}',
		pageHier4: '[[mapping.pagealias.pageHier4]] >> {{REMOVEKEY}}',
		siteDomain:
			window?.DDC?.dataLayer?.dealership?.site?.siteInfo?.domain?.replace?.(
				/^https?:\/\//,
				''
			),
		siteLanguageCode: '[[lookup.locale]]'
	}
};

const variant =
	pageInfo[window?.DDC?.dataLayer?.page?.trackingTags?.pagegroup] ||
	pageInfo.variant1;

export default {
	events: {
		'ddc.wstagging.first': [
			{
				payload: {
					digitalData: {
						pageInfo: {
							...pageInfo.default,
							...variant
						},
						visitorProfile: {
							zipCode: '[[DDC.dataLayer.user.userPostalCode]]'
						},
						vehicleInfo: {
							bodyStyle: '[[bodyStyle]] >> {{REMOVEKEY}}',
							condition: '[[newOrUsed]] >> {{REMOVEKEY}}',
							make: '[[make]] >> {{REMOVEKEY}}',
							modelName: '[[model]] >> {{REMOVEKEY}}',
							modelYear: '[[year]] >> {{REMOVEKEY}}',
							price: '[[internetPrice]] >> {{REMOVEKEY}}',
							trimLevel: '[[trim]] >> {{REMOVEKEY}}',
							vehicleType: '[[bodyStyle]] >> {{REMOVEKEY}}',
							vin: '[[vin]] >> {{REMOVEKEY}}'
						},
						internalCampaignInfo: {
							internalSearchTerms:
								'[[fn.getInternalSearchTerms()]] >> {{REMOVEKEY}}'
						}
					}
				}
			}
		],
		'ddc.page.view': [
			{
				payload: {
					directCallEvent: 'general.bottom.of.page'
				}
			}
		],
		'ddc.slideshow.click': [
			{
				payload: {
					directCallEvent: 'image.link',
					additionalData: {
						customLink: ({
							eventData: { name, trackingSection }
						}) =>
							typeof name !== 'undefined'
								? `${trackingSection}:${name}`
								: '[[eventData.trackingSection]]:[[eventData.attributes.class]]',
						element:
							'{"id":"[[eventData.attributes.id]]","className":"[[eventData.attributes.class]]","href":"[[eventData.attributes.rawHref]]",' +
							// this break is needed because our stupid linter freaks out over long lines
							'"tagName":"[[eventData.attributes.tagName]]","innerText":"[[eventData.attributes.innerText]]",' +
							'"type":"[[eventData.attributes.type]]"}',
						linkUrl: '[[eventData.url]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: '[[eventData.trackingSection]]',
						slideOrder: '[[eventData.position]]'
					}
				}
			}
		],
		'ddc.slideshow.pagerClick': [
			{
				payload: {
					directCallEvent: 'text.link',
					additionalData: {
						customLink:
							'[[eventData.position]]:pager:[[eventData.destinationIndex]]',
						element:
							'{"id":"[[eventData.attributes.id]]","className":"[[eventData.attributes.class]]","href":"[[eventData.attributes.rawHref]]",' +
							// this break is needed because our stupid linter freaks out over long lines
							'"tagName":"[[eventData.attributes.tagName]]","innerText":"[[eventData.attributes.innerText]]","type":"[[eventData.attributes.type]]"}',
						interactionValue:
							'[[eventData.currentItem]]/[[eventData.totalItems]]',
						interactionLabel: 'dots',
						linkUrl: '[[eventData.linkUrl]]',
						linkText: '[[eventData.linkText]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: '[[eventData.position]]'
					}
				}
			}
		],
		'ddc.link.navClick': [
			{
				payload: {
					directCallEvent: 'nav.link',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.linkText]]',
						position: '[[eventData.position]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						linkText: '[[eventData.linkText]]',
						linkUrl: '[[eventData.url]]'
					}
				}
			}
		],
		'ddc.link.socialHeaderClick': [
			{
				payload: {
					directCallEvent: 'link.social.header.click',
					additionalData: {
						customLink: 'Global Navigation:[[eventData.service]]',
						position: 'Global Navigation',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						linkText: '[[eventData.service]]',
						url: '[[eventData.url]]'
					}
				}
			}
		],
		'ddc.link.socialShare': [
			{
				payload: {
					directCallEvent: 'footer.social.icons',
					additionalData: {
						customLink:
							'[[eventData.widgetHeading]]:[[eventData.service]]',
						position: '[[eventData.widgetHeading]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						linkText: '[[eventData.service]]',
						url: '[[eventData.url]]'
					}
				}
			}
		],
		'ddc.form.change': [
			{
				logic: {
					linkType: 'select-one',
					// Worth noting that this event is being pushed from ws-inv-filters despite the name being set to ws-inv-listing
					widgetName: 'ws-inv-listing'
				},
				payload: {
					directCallEvent: 't3TrackDropDown',
					additionalData: {
						searchFilterLabel: 'inventory sort by',
						searchFilterValue: '[[eventData.label]]'
					}
				}
			}
		],
		'ddc.form.onPage': [
			{
				payload: {
					directCallEvent: 'form.show',
					additionalData: '[[fn.getDefaultFormOnPagePayload()]]'
				}
			}
		],
		'ddc.form.submission': [
			{
				payload: {
					directCallEvent: 'form.submission',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[fn.getAppropriateFormName()]]',
						formName: '[[fn.getAppropriateFormName()]]',
						isModal: '[[eventData.isModal]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						trackingId: '[[eventData.trackingId]]',
						position: '[[eventData.trackingSection]]',
						formLeadId:
							'[[eventData.formEventId]] >> {{EMPTYSTRING}}',
						formType:
							'[[mapping.form.[[eventData.trackingId]].formType]]',
						formCategory:
							'[[mapping.form.[[eventData.trackingId]].formCategory]]'
					}
				}
			}
		],
		'ddc.form.confirmation': [
			{
				logic: () => {
					const {
						dataLayer: {
							page: {
								pageInfo: { isVlp, isShowroomOverview } = {}
							} = {}
						}
					} = window.DDC;

					return (
						!isShowroomOverview &&
						(isVlp ||
							window.DDC.WidgetData['ws-tracking']
								?.confirmationData?.form?.fields?.fromVlp)
					);
				},
				payload: {
					directCallEvent: 'form.confirmation',
					additionalData: {
						formName: 'VLP:[[fn.getAppropriateFormName()]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						formLeadId:
							'[[eventData.formEventId]] >> {{EMPTYSTRING}}',
						formType:
							'[[mapping.form.[[eventData.trackingId]].formType]]',
						formCategory:
							'[[mapping.form.[[eventData.trackingId]].formCategory]] >> lead'
					}
				}
			},
			{
				logic: () => {
					const {
						dataLayer: { page: { pageInfo: { isVdp } = {} } = {} }
					} = window.DDC;

					return (
						isVdp ||
						window.DDC.WidgetData['ws-tracking']?.confirmationData
							?.form?.fields?.fromVdp
					);
				},
				payload: {
					directCallEvent: 'form.confirmation',
					additionalData: {
						formName: 'VDP:[[fn.getAppropriateFormName()]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						formLeadId:
							'[[eventData.formEventId]] >> {{EMPTYSTRING}}',
						formType:
							'[[mapping.form.[[eventData.trackingId]].formType]]',
						formCategory:
							'[[mapping.form.[[eventData.trackingId]].formCategory]] >> lead'
					}
				}
			},
			{
				payload: {
					directCallEvent: 'form.confirmation',
					additionalData: {
						formName: '[[fn.getAppropriateFormName()]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						formLeadId:
							'[[eventData.formEventId]] >> {{EMPTYSTRING}}',
						formType:
							'[[mapping.form.[[eventData.trackingId]].formType]]',
						formCategory:
							'[[mapping.form.[[eventData.trackingId]].formCategory]] >> lead'
					}
				}
			}
		],
		'ddc.form.initiation': [
			{
				payload: {
					directCallEvent: 'form.initiation',
					digitalData: '[[fn.getFormInitiationDigitalData()]]',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[fn.getAppropriateFormName()]] - [[eventData.activeElement]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: '[[eventData.trackingSection]]',
						formLeadId:
							'[[eventData.formEventId]] >> {{EMPTYSTRING}}',
						formName: '[[fn.getAppropriateFormName()]]',
						formType:
							'[[mapping.form.[[eventData.trackingId]].formType]]',
						formCategory:
							'[[mapping.form.[[eventData.trackingId]].formCategory]]',
						formFieldName: '[[fn.getFormFieldName()]]'
					}
				}
			}
		],
		'ddc.form.inventorySearchLeadChange': [
			{
				payload: {
					directCallEvent: 'form.inventory.search.lead.change',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.label]]',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						toggle: '[[eventData.customLinkLabel]] >> [[eventData.attributes.name]]'
					}
				}
			}
		],
		'ddc.form.facetbrowsechange': [
			{
				logic: {
					'eventData.widgetName': 'video-gallery'
				},
				payload: {
					directCallEvent: 'form.facet.browse.change',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.label]]',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						toggle: '[[eventData.label]] >> [[eventData.name]]',
						label: '[[eventData.firstOptionText]]',
						value: '[[eventData.selectedValue]] >> [[eventData.label]]'
					}
				}
			},
			{
				payload: {
					directCallEvent: 'form.facet.browse.change',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.label]]',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						toggle: '[[eventData.customLinkLabel]] >> [[eventData.name]]'
					}
				}
			}
		],
		'ddc.form.facetBrowseChange': [
			{
				logic: {
					'eventData.widgetName': 'video-gallery'
				},
				payload: {
					directCallEvent: 'form.facet.browse.change',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.label]]',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						toggle: '[[eventData.label]] >> [[eventData.name]]',
						label: '[[eventData.firstOptionText]]',
						value: '[[eventData.selectedValue]] >> [[eventData.label]]'
					}
				}
			},
			{
				payload: {
					directCallEvent: 'form.facet.browse.change',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.label]]',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						toggle: '[[eventData.customLinkLabel]] >> [[eventData.name]]'
					}
				}
			}
		],
		'ddc.form.slideChange': [
			{
				payload: {
					directCallEvent: 'ddc.form.slideChange',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.label]]',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						toggle: '[[eventData.label]] >> [[eventData.name]] >> {{UNDEFINED}}'
					}
				}
			}
		],
		'ddc.page.vehicleDetailView': [
			{
				payload: {
					directCallEvent: 'vdp.bottom.of.page'
				}
			}
		],
		'ddc.inventory.filterSearch': [
			{
				payload: ({ eventData: { queryFacets, resultCount } }) => {
					let payload;
					const facets = Object.keys(queryFacets);
					if (facets.length === 0) {
						payload = {
							directCallEvent: 't3TrackInventoryResults',
							additionalData: {
								customLink: '[[fn.getSiteSection5()]]',
								position: '[[fn.getSiteSection5()]]',
								pageName: window.digitalData.pageInfo.pageName,
								resultCount,
								queryFacets: ''
							}
						};
					}
					if (facets.length === 1) {
						payload = {
							directCallEvent: 't3TrackInventoryResults',
							additionalData: {
								customLink:
									'[[fn.getSiteSection5()]]:[[fn.getFilteredSearchFacetsStr()]]',
								position: '[[fn.getSiteSection5()]]',
								pageName: window.digitalData.pageInfo.pageName,
								resultCount,
								inventoryFilterLabel: facets[0],
								inventoryFilterValue: queryFacets[facets[0]]
							}
						};
					}
					if (facets.length > 1) {
						payload = {
							directCallEvent: 't3TrackInventoryResultsKvp',
							additionalData: {
								customLink:
									'[[fn.getSiteSection5()]]:[[fn.getFilteredSearchFacetsStr()]]',
								position: '[[fn.getSiteSection5()]]',
								pageName: window.digitalData.pageInfo.pageName,
								resultCount,
								inventoryFilterKvp: queryFacets
							}
						};
					}
					return payload;
				}
			}
		],
		'ddc.link.hproductClick': [
			{
				payload: {
					directCallEvent: 'link.hproduct.click',
					additionalData: {
						customLink:
							'[[fn.getSiteSection5()]]:[[eventData.vin]] >> [[eventData.model]]',
						position: '[[fn.getSiteSection5()]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						linkText: '[[eventData.text]]',
						linkUrl: '[[eventData.url]]',
						vehicleInfo: {
							modelYear: '[[eventData.modelYear]]',
							make: '[[eventData.make]]',
							modelName: '[[eventData.model]]',
							bodyStyle: '[[eventData.bodyStyle]]',
							trimLevel: '[[eventData.trim]]',
							condition: '[[eventData.type]]',
							vin: '[[eventData.year]]',
							exteriorColor: '[[eventData.exteriorColor]]',
							internetPrice: '[[eventData.internetPrice]]',
							msrp: '[[eventData.msrp]]'
						}
					}
				}
			}
		],
		'ddc.link.recommendedVehicle': [
			{
				payload: {
					directCallEvent: 'link.recommended.vehicles',
					additionalData: {
						customLink:
							'[[eventData.widgetHeading]]:[[eventData.text]]',
						position: '[[eventData.widgetHeading]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						url: '[[eventData.url]]'
					}
				}
			}
		],
		'ddc.link.vehicleCompareCheck': [
			{
				payload: {
					directCallEvent: 'link.vehicleCompareCheck',
					additionalData: {
						customLink:
							'[[fn.getSiteSection5()]]:[[eventData.vin]] >> [[eventData.model]]',
						position: '[[fn.getSiteSection5()]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						vehicleInfo: {
							modelYear: '[[eventData.modelYear]]',
							make: '[[eventData.make]]',
							modelName: '[[eventData.model]]',
							bodyStyle: '[[eventData.bodyStyle]]',
							trimLevel: '[[eventData.trim]]',
							condition: '[[eventData.type]]',
							vin: '[[eventData.year]]',
							exteriorColor: '[[eventData.exteriorColor]]',
							internetPrice: '[[eventData.internetPrice]]',
							msrp: '[[eventData.msrp]]'
						}
					}
				}
			}
		],
		'ddc.link.generic': [
			{
				// if variant2 in trackingTags, then use this block for link clicks
				logic: () =>
					window?.DDC?.dataLayer?.page?.trackingTags?.pagegroup ===
					'variant2',
				payload: {
					directCallEvent: 't3TrackLinkClick',
					additionalData: {
						linkText: '[[eventData.text]]',
						linkUrl: '[[eventData.url]]'
					}
				}
			},
			{
				// do not handle inventory facet accordion here, we will use the WUE for that
				logic: ({
					eventData: {
						attributes: { 'aria-expanded': ariaExpanded, id } = {},
						widgetName
					} = {}
				}) => {
					const wsFacetsPanel =
						ariaExpanded &&
						widgetName === 'ws-inv-facets' &&
						id.includes('panel-title');
					const wsDetailedSpecs =
						ariaExpanded && widgetName === 'ws-detailed-specs';
					return wsFacetsPanel || wsDetailedSpecs;
				}
			},
			{
				logic: {
					isIncentivePanel: true
				},
				payload: {
					directCallEvent: 't3TrackOfferDetails',
					additionalData: {
						customLink: 'panel-title:[[eventData.dataIncentiveId]]',
						position: 'panel-title',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						offerId: '[[eventData.dataIncentiveId]]',
						offerName: '[[eventData.dataIncentiveName]]',
						offerText: '[[eventData.dataIncentiveName]]'
					}
				}
			},
			{
				logic: ({
					eventData: {
						pageName = '',
						attributes: { class: className = '' }
					}
				}) => {
					return (
						className.includes('btn') &&
						(pageName === 'SHOWROOM' ||
							window?.DDC?.dataLayer?.page?.trackingTags
								?.pagegroup === 'mslp')
					);
				},
				payload: {
					directCallEvent: 't3TrackLinkClick',
					additionalData: {
						linkText: ({ eventData: { text } }) => text,
						linkUrl: ({ eventData: { url } }) => url
					}
				}
			},
			{
				logic: ({
					eventData: {
						pageName = '',
						widgetName = '',
						attributes: { class: className = '' }
					}
				}) => {
					return (
						className.includes('tab') &&
						(pageName === 'SHOWROOM' ||
							window?.DDC?.dataLayer?.page?.trackingTags
								?.pagegroup === 'mslp') &&
						widgetName === 'content-tabbed'
					);
				},
				payload: ({
					eventData: { section, text, widgetClasses = '' }
				}) => {
					const interactionLabel =
						widgetClasses.includes('tracking-tag-features') &&
						'features';

					return {
						directCallEvent: 't3TrackToggle',
						additionalData: {
							interactionLabel:
								interactionLabel || section || 'Unknown Label',
							interactionValue: text
						}
					};
				}
			},
			{
				logic: {
					isTelephonicUrl: true
				},
				payload: {
					directCallEvent: 'telephone.dial',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.department]]:call',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						department: '[[eventData.department]]',
						phoneNumber: '[[fn.getTelephone()]]'
					}
				}
			},
			{
				payload: {
					directCallEvent: '[[fn.getLinkType()]]',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.text]]',
						element: '[[fn.getElementForLinkClicks()]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: '[[eventData.trackingSection]]',
						linkText: '[[eventData.text]]',
						linkUrl: '[[eventData.url]]',
						interactionLabel:
							'[[eventData.showroomSectionHeading]] >> [[eventData.slideControlLabel]]',
						interactionValue: ({
							eventData: {
								currentItem,
								interactionValue,
								totalItems
							}
						}) =>
							defined(currentItem) && defined(totalItems)
								? `${currentItem}/${totalItems}`
								: interactionValue,
						searchFilterLabel: '[[eventData.label]]',
						expand: '[[eventData.expand]]',
						label: '[[eventData.label]]'
					}
				}
			}
		],
		'ddc.link.getDirections': [
			{
				payload: {
					directCallEvent: 'link.get.directions',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.linkText]]',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						linkText: '[[eventData.linkText]]'
					}
				}
			}
		],
		'ddc.video.play': [
			{
				logic: () =>
					window?.DDC?.dataLayer?.page?.trackingTags?.pagegroup ===
					'variant2',
				payload: {
					directCallEvent: 't3TrackVideoPlay',
					additionalData: {
						videoName:
							'[[fn.getVideoName()]] >> [[DDC.dataLayer.page.trackingTags.videoname1]] >> {{EMPTYSTRING}}'
					}
				}
			},
			{
				payload: {
					directCallEvent: 'vdp.video.play',
					additionalData: {
						fileType: '[[eventData.fileType]]',
						videoDuration: '[[eventData.videoDuration]]',
						videoSource: '[[eventData.videoSource]]',
						videoName: '[[fn.getVideoName()]]'
					}
				}
			}
		],
		'ddc.video.milestone': [
			{
				logic: ({ eventData }) =>
					eventData.videoMilestone === 'complete' &&
					window?.DDC?.dataLayer?.page?.trackingTags?.pagegroup ===
						'variant2',
				payload: {
					directCallEvent: 't3TrackVideoCompleted',
					additionalData: {
						videoName:
							'[[fn.getVideoName()]] >> [[DDC.dataLayer.page.trackingTags.videoname1]] >> {{EMPTYSTRING}}'
					}
				}
			},
			{
				logic: {
					'eventData.videoMilestone': 'complete'
				},
				payload: {
					directCallEvent: 'vdp.video.complete',
					additionalData: {
						fileType: '[[eventData.fileType]]',
						videoDuration: '[[eventData.videoDuration]]',
						videoSource: '[[eventData.videoSource]]',
						videoName: '[[fn.getVideoName()]]'
					}
				}
			}
		],
		'ddc.link.offerClick': [
			{
				logic: ({ eventData }) => !eventData.isIncentiveModal,
				payload: {
					directCallEvent: 'offer.click',
					additionalData: {
						customLink:
							'[[eventData.trackingSection]]:[[eventData.offerId]]',
						position: '[[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						offerId: '[[eventData.offerId]]',
						offerName: '[[eventData.offerName]]'
					}
				}
			}
		],
		'ddc.link.comparePageClick': [
			{
				payload: {
					directCallEvent: 'link.compare.page.click',
					additionalData: {
						customLink: 'inventory:[[eventData.vin]]',
						linkText: '[[fn.getComparePageClickLinkText()]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: 'inventory',
						vehicleInfo: {
							bodyStyle: '[[eventData.bodyStyle]]',
							make: '[[eventData.make]]',
							modelName: '[[eventData.model]]',
							modelYear: '[[eventData.year]]',
							trimLevel: '[[eventData.trim]]',
							vehicleType: '[[eventData.type]]',
							vin: '[[eventData.vin]]'
						}
					}
				}
			}
		],
		'ddc.maps': [
			{
				payload: {
					directCallEvent: 'map.show'
				}
			}
		],
		widgetUserEvent: [
			{
				logic: {
					widgetName: 'ws-detailed-specs'
				},
				payload: ({ eventData: { action, element, result } = {} }) => {
					let payload;
					let resultOfClick;
					if (result.includes('expanded')) {
						resultOfClick = 'expanded';
					}
					if (result.includes('collapsed')) {
						resultOfClick = 'collapsed';
					}
					if (action === 'clicked' && resultOfClick) {
						payload = {
							directCallEvent: 't3TrackAccordion',
							additionalData: {
								interactionLabel: 'detailed specifications',
								interactionValue: `${element
									?.replace('accordion', '')
									?.toLowerCase()}| ${resultOfClick}`
							}
						};
					}
					return payload;
				}
			},
			{
				logic: {
					widgetName: 'ws-inv-facets'
				},
				payload: ({ eventData: { action, element } = {} }) => {
					let payload;
					if (['expanded', 'collapsed'].includes(action)) {
						const [facet] = element?.split?.(' ');
						payload = {
							directCallEvent: 't3TrackAccordion',
							additionalData: {
								interactionLabel: 'inventory listing facets',
								interactionValue: `${facet} | ${action}`
							}
						};
					}
					return payload;
				}
			},
			{
				logic: {
					widgetName: 'ws-rec-vehicles',
					action: 'clicked'
				},
				payload: {
					directCallEvent: 'link.recommended.vehicles',
					additionalData: {
						customLink:
							'[[eventData.widgetName]]:[[eventData.title]] [[eventData.subtitle]]',
						position: '[[eventData.widgetName]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						url: '[[eventData.link]]'
					}
				}
			},
			{
				logic: {
					result: 'search modal initiated',
					widgetId: 'inventory-search1',
					widgetName: 'ws-inv-text-search'
				},
				payload: {
					additionalData: {
						customLink:
							'inventory-search1:ws-inv-text-search - search',
						formName: 'ws-inv-text-search',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: 'inventory-search1'
					},
					digitalData: {
						formInfo: {
							formFieldName: 'search',
							formName: 'ws-inv-text-search'
						}
					},
					directCallEvent: 'form.initiation'
				}
			},
			{
				logic: {
					result: 'search modal initiated',
					widgetId: 'template-site-search1',
					widgetName: 'ws-site-text-search'
				},
				payload: {
					additionalData: {
						customLink: 'Global Nav:ws-site-text-search - search',
						formName: 'ws-site-text-search',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: 'Global Nav'
					},
					digitalData: {
						formInfo: {
							formFieldName: 'search',
							formName: 'ws-site-text-search'
						}
					},
					directCallEvent: 'form.initiation'
				}
			},
			{
				logic: {
					result: 'search modal initiated',
					widgetId: 'site-search1',
					widgetName: 'ws-site-text-search'
				},
				payload: {
					additionalData: {
						customLink: 'site-search1:ws-site-text-search - search',
						formName: 'ws-site-text-search',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: 'site-search1'
					},
					digitalData: {
						formInfo: {
							formFieldName: 'search',
							formName: 'ws-site-text-search'
						}
					},
					directCallEvent: 'form.initiation'
				}
			},
			{
				logic: {
					mustNotEqual: {
						'eventData.result': ['Favorite added', 'Vehicle saved']
					},
					widgetName: 'ws-vehicle-media'
				},
				payload: {
					additionalData: {
						customLink:
							'Carousel:[[eventData.widgetState]]:[[eventData.element]]',
						element: '[[eventData.element]]',
						interactionLabel: ({ eventData: { element } }) => {
							let interactionLabel;

							if (element.includes('Thumbnail Carousel')) {
								interactionLabel = 'thumbnail';
							}

							if (element.includes('Next')) {
								interactionLabel = 'next';
							}

							if (element.includes('Previous')) {
								interactionLabel = 'previous';
							}

							return interactionLabel;
						},
						interactionValue: ({
							eventData: { currentItem, totalItems }
						}) => {
							let interactionValue;

							if (defined(currentItem) && defined(totalItems)) {
								interactionValue = `${currentItem}/${totalItems}`;
							}

							return interactionValue;
						},
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: 'Carousel',
						result: '[[eventData.result]]'
					},
					directCallEvent: ({ eventData: { action, element } }) => {
						let directCallEvent = 'image.link';

						if (action === 'swiped') {
							directCallEvent = 'carousel swiped';
						}

						if (element.includes('Button')) {
							directCallEvent = 'button.link';
						}

						if (element.includes('Next')) {
							directCallEvent = 'arrow.next';
						}

						if (element.includes('Previous')) {
							directCallEvent = 'arrow.prev';
						}

						return directCallEvent;
					}
				}
			},

			{
				logic: {
					widgetName: 'ws-vehicle-gallery'
				},
				payload: {
					additionalData: {
						customLink:
							'Carousel:[[eventData.widgetState]]:[[eventData.element]]',
						element: '[[eventData.element]]',
						interactionLabel: ({ eventData: { element } }) => {
							let interactionLabel;

							if (element.includes('Photo Carousel thumbnail')) {
								interactionLabel = 'thumbnail';
							}

							if (element.includes('Next')) {
								interactionLabel = 'next';
							}

							if (element.includes('Previous')) {
								interactionLabel = 'previous';
							}

							return interactionLabel;
						},
						interactionValue: ({
							eventData: { currentItem, totalItems }
						}) => {
							let interactionValue;

							if (defined(currentItem) && defined(totalItems)) {
								interactionValue = `${currentItem}/${totalItems}`;
							}

							return interactionValue;
						},
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: 'Carousel',
						result: '[[eventData.result]]'
					},
					directCallEvent: ({ eventData: { action, element } }) => {
						let directCallEvent = 'image.link';

						if (action === 'swipe') {
							directCallEvent = 'carousel swiped';
						}

						if (element.includes('Button')) {
							directCallEvent = 'button.link';
						}

						if (element.includes('Next')) {
							directCallEvent = 'arrow.next';
						}

						if (element.includes('Previous')) {
							directCallEvent = 'arrow.prev';
						}

						return directCallEvent;
					}
				}
			},
			{
				logic: {
					action: 'applied',
					result: 'Results updated with facet ',
					widgetName: 'ws-facet-browse'
				},
				payload: {
					directCallEvent: 'form.facet.browse.change',
					additionalData: {
						customLink:
							'[[eventData.widgetId]]:[[eventData.element]]',
						label: '[[eventData.element]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: '[[eventData.widgetId]]',
						value: '[[eventData.elementCTA]]'
					}
				}
			},
			{
				logic: {
					action: 'clicked',
					result: 'User navigates to search results page',
					widgetName: 'ws-facet-browse'
				},
				payload: {
					directCallEvent: 'search.link',
					additionalData: {
						customLink:
							'[[eventData.widgetId]]:[[eventData.element]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						position: '[[eventData.widgetId]]',
						linkText: '[[eventData.element]]'
					}
				}
			},
			{
				logic: ({ eventData: { widgetName = '', action = '' } }) =>
					widgetName === 'ws-accordion-content' &&
					action === 'clicked',
				payload: {
					directCallEvent: 't3TrackAccordion',
					additionalData: {
						interactionLabel: ({ eventData: { element } }) =>
							element || 'Unknown Accordion',
						interactionValue: ({ eventData: { elementCTA } }) =>
							elementCTA
					}
				}
			},
			{
				logic: ({
					eventData: {
						action = '',
						widgetName = '',
						elementType = '',
						result = ''
					}
				}) =>
					action === 'clicked' &&
					widgetName === 'ws-content-cta' &&
					elementType === 'notAnchorNorButton' &&
					result?.includes?.('.pdf') &&
					window?.DDC?.dataLayer?.page?.trackingTags?.pagegroup ===
						'mslp',
				payload: {
					directCallEvent: 't3TrackDownloadBrochure',
					additionalData: {
						brochureName: '[[eventData.url]]'
					}
				}
			},
			{
				logic: {
					action: 'clicked',
					widgetName: 'ws-content-cta',
					elementType: 'notAnchorNorButton'
				},
				payload: {
					directCallEvent: 't3TrackLinkClick',
					additionalData: {
						linkText: ({
							eventData: { reactElementText, elementCTA }
						}) => {
							if (
								reactElementText &&
								typeof reactElementText === 'string' &&
								reactElementText !== ''
							) {
								return reactElementText;
							} else {
								return elementCTA;
							}
						},
						linkUrl: '[[eventData.url]]'
					}
				}
			}
		],
		specialsEvent: [
			{
				logic: {
					widgetName: 'ws-specials',
					specialType: 'click'
				},
				payload: {
					directCallEvent: '[[fn.getSpecialsEventDirectCallEvent()]]',
					additionalData: {
						position:
							'[[eventData.specialPlacementType]] >> [[eventData.trackingSection]]',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						offerId: '[[eventData.specialId]]',
						offerName: '[[eventData.specialHeading]]',
						offerYear: '[[eventData.specialYear]]',
						offerMake: '[[eventData.specialMake]]',
						offerModel: '[[eventData.specialModel]]',
						customLink: '[[fn.getSpecialsEventCustomLink()]]'
					}
				}
			}
		],
		'ddc.inventory.typedSearch': [
			{
				payload: {
					directCallEvent: 'typed.search.results',
					additionalData: {
						customLink:
							'inventory:[[eventData.queryFacets.search]]',
						position: 'inventory',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						resultCount: '[[eventData.resultCount]] >> 0',
						queryFacets: '[[eventData.queryFacets.search]]'
					}
				}
			}
		],
		'ddc.inventory.typedSearch.init': [
			{
				payload: {
					directCallEvent: 'typed.search.init',
					additionalData: {
						customLink: 'inventory:[[eventData.search]]',
						position: 'inventory',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						search: '[[eventData.search]]'
					}
				}
			}
		],
		'ddc.incentive.filterSearch': [
			{
				payload: {
					directCallEvent: 'incentive.filter',
					additionalData: {
						customLink:
							'incentives:[[eventData.clickedFacetName]]-[[eventData.clickedFacetValue]]:[[eventData.isChecked]]',
						position: 'incentives',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						queryFacets: '[[eventData.facets]]'
					}
				}
			}
		],
		'ddc.form.paymentCalcInit': [
			{
				payload: {
					directCallEvent: 'form.payment.calc.init',
					additionalData: {
						customLink: 'finance:paymentCalculator',
						position: 'finance',
						pageName: '[[window.digitalData.pageInfo.pageName]]'
					}
				}
			}
		],
		'ddc.form.typedSearch': [
			{
				payload: {
					directCallEvent: 'typed.search.submit',
					additionalData: {
						customLink:
							'Typed Search Form:[[eventData.typedSearchContent]]',
						position: 'Typed Search Form',
						pageName: '[[window.digitalData.pageInfo.pageName]]',
						typedSearchContent: '[[eventData.typedSearchContent]]'
					}
				}
			}
		],
		'ddc.dialog.ajaxContentLoaded': [
			{
				payload: {
					directCallEvent: 'dialog.ajax.content.loaded',
					additionalData: {
						hasForm: '[[eventData.hasForm]]'
					}
				}
			}
		],
		'ddc.dialog.opened': [
			{
				payload: {
					directCallEvent: 'dialog.opened',
					additionalData: {
						customLink: 'dialog:[[eventData.dialogTitle]]',
						position: 'dialog',
						pageName: '[[window.digitalData.pageInfo.pageName]]'
					}
				}
			}
		],
		'ddc.dialog.closed': [
			{
				payload: {
					directCallEvent: 'dialog.closed',
					additionalData: {
						customLink: 'dialog:[[eventData.dialogTitle]]',
						position: 'dialog',
						pageName: '[[window.digitalData.pageInfo.pageName]]'
					}
				}
			}
		],
		'ddc.click.tab': [
			{
				payload: {
					directCallEvent: 't3TrackToggle',
					additionalData: {
						interactionLabel:
							'[[eventData.showroomSection]] >> [[eventData.trackingSection]]',
						interactionValue: '[[eventData.text]]'
					}
				}
			}
		],
		'ddc.click.colorpicker': [
			{
				payload: {
					directCallEvent: 't3TrackColorPicker',
					additionalData: {
						interactionLabel: 'exterior',
						interactionValue: '[[eventData.color]]'
					}
				}
			}
		],
		'ddc.showroom.cta': [
			{
				payload: {
					directCallEvent: 't3TrackLinkClick',
					additionalData: {
						linkText: '[[eventData.text]]',
						linkUrl: '[[eventData.url]]'
					}
				}
			}
		],
		'ddc.click.accordion': [
			{
				payload: {
					directCallEvent: 't3TrackAccordion',
					additionalData: {
						interactionLabel: '[[eventData.showroomSection]]',
						interactionValue: '[[eventData.text]]'
					}
				}
			}
		]
	}
};
